<template>
    <Teleport to="body">
        <div class="modal show">
            <div class="modal-backdrop show" :style="{ zIndex: 'unset' }" @click.self="close()"></div>
            <section class="modal-dialog" :style="{ zIndex: 1 }">
                <div class="container popup">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="modal-title">{{ trans('Confirm') }}</div>

                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="close()"
                                :disabled="loading"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" v-if="!loading">
                            <div v-html="this.htmlBody"></div>
                            <strong>{{ this.subtitle }}</strong>
                            {{ this.body }}
                        </div>
                        <div class="modal-body" v-if="loading">
                            <div class="text-center">
                                <i class="icofont-spinner"></i>
                            </div>
                        </div>
                        <!--/ modal-body -->

                        <div class="modal-footer">
                            <button
                                type="button"
                                @click="close()"
                                class="btn btn-secondary"
                                :disabled="loading"
                            >
                                {{ trans('Cancel') }}
                            </button>
                            <button
                                type="button"
                                class="btn btn-primary"
                                @click="succes()"
                                :disabled="loading"
                            >
                                {{ trans('Confirm') }}
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </Teleport>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: {
        body: {
            type: String,
            required: true,
            default: null,
        },
        subtitle: {
            required: false,
            default: null,
        },
        htmlBody: {
            required: false,
            default: null,
        },
        loading: {
            default: false,
        },
    },
    methods: {
        close() {
            if (this.loading) {
                return;
            }
            this.$emit('close');
        },
        succes() {
            this.$emit('succes');
        },
    },
    created() {},
    watch: {},
};
</script>
<style lang="css" scoped></style>
